import type { Measure } from './lines';

let ctx: CanvasRenderingContext2D | null | undefined;

/** Main-thread natural width measurer for the fidelity check. Undefined when no canvas is available (tests). */
export function domMeasure(): Measure | undefined {
  if (ctx === undefined) {
    try { ctx = typeof document !== 'undefined' ? document.createElement('canvas').getContext('2d') : null; } catch { ctx = null; }
  }
  if (!ctx) return undefined;
  const c = ctx;
  const cache = new Map<string, number>();
  return (text, family, size, spacing) => {
    const key = `${family}|${size}|${spacing}|${text}`;
    const hit = cache.get(key);
    if (hit !== undefined) return hit;
    c.font = `${size}px "${family}"`;
    const w = c.measureText(text).width + spacing * text.length;
    cache.set(key, w);
    return w;
  };
}
